import { render, staticRenderFns } from "./Testcases.vue?vue&type=template&id=87f7ffa8"
import script from "./Testcases.vue?vue&type=script&lang=js"
export * from "./Testcases.vue?vue&type=script&lang=js"
import style0 from "./Testcases.vue?vue&type=style&index=0&id=87f7ffa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports